import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux'
import type { IRootState } from './reducer'
import type { AppDispatch } from './types'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch = () => useReduxDispatch<AppDispatch>()
export const useSelector = <TSelected>(selector: (state: IRootState) => TSelected): TSelected =>
  useReduxSelector(selector)
